import { DiagramDefinition } from "../types";

export const m007Definition: DiagramDefinition = {
  id: "M-007",
  title: "Authentication Providers Architecture",
  description:
    "Solarch Auth Router supporting 4 authentication methods: Password bcrypt, OAuth2 (GitHub, Google, Discord), Passwordless OTP email, and MFA TOTP, signing tokens through the Solarch JWT Signer.",
  viewBox: "0 0 900 360",
  nodes: [
    { id: "Client", kind: "client", label: "Client App", subtext: "Frontend / Mobile", position: [100, 180], size: [140, 48] },
    { id: "AuthRouter", kind: "service", label: "Auth Router", subtext: "Provider Switch", position: [270, 180], size: [140, 48] },

    // Auth Providers Column
    { id: "PasswordAuth", kind: "service", label: "1. Password Auth", subtext: "bcrypt Hashing", position: [460, 60], size: [150, 44] },
    { id: "OAuth2Auth", kind: "service", label: "2. OAuth2 Auth", subtext: "GitHub / Google", position: [460, 140], size: [150, 44] },
    { id: "OTPAuth", kind: "service", label: "3. OTP Auth", subtext: "6-Digit Email Code", position: [460, 220], size: [150, 44] },
    { id: "MFAAuth", kind: "service", label: "4. MFA Auth", subtext: "TOTP Verifier", position: [460, 300], size: [150, 44] },

    { id: "JWTEngine", kind: "service", label: "JWT Signer", subtext: "Solarch Token", position: [650, 180], size: [140, 48] },
    { id: "Response", kind: "status", label: "200 OK + JWT", subtext: "User Record Payload", position: [810, 180], size: [125, 45], statusColor: "#22c55e" },
  ],
  edges: [
    { id: "e1", source: "Client", target: "AuthRouter", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "AuthRouter", target: "PasswordAuth", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e3", source: "AuthRouter", target: "OAuth2Auth", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e4", source: "AuthRouter", target: "OTPAuth", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e5", source: "AuthRouter", target: "MFAAuth", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e6", source: "PasswordAuth", target: "JWTEngine", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e7", source: "OAuth2Auth", target: "JWTEngine", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e8", source: "OTPAuth", target: "JWTEngine", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e9", source: "MFAAuth", target: "JWTEngine", sourcePort: "right", targetPort: "left", routing: "orthogonal" },
    { id: "e10", source: "JWTEngine", target: "Response", sourcePort: "right", targetPort: "left", routing: "straight" },
  ],
};
